import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
@Injectable()
export class PwaService {
 serviceWorkerWatch$ =  new BehaviorSubject(null)
    promptEvent: any;
  constructor(private swUpdate: SwUpdate) {
    window.addEventListener('beforeinstallprompt', (event: any) => {
        this.promptEvent = event;
      });
    swUpdate.available.subscribe(event => {
    //   if (askUserToUpdate()) {
    //     window.location.reload();
        this.serviceWorkerWatch$.next(event);
    //   }
    });
  }
}